import React from "react";
import Navigation from "../../Component/Navigation";


const Portfolio = () => {
  return (
    <section>
      <Navigation />
      
    </section>
  );
};

export default Portfolio;
